import React, { useEffect, useMemo, useRef, useState } from 'react';
import * as THREE from '../../../../dist/three.module.js';
import { fmesh, fmeshPoints } from '../../../core/globalVariables.js';
import Chart from 'chart.js/auto';
// import zoomPlugin from 'chartjs-plugin-zoom';
import 'chartjs-adapter-date-fns';
import axios from 'axios';
import mapboxgl from 'mapbox-gl';
import DynamicLineChart from './realmComponents/DynamicLineChart.js'
import DynamicPieChart from './realmComponents/DynamicPieChart.js'
import DynamicScatterChart from './realmComponents/DynamicScatterChart.js';
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosClose } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import * as turf from '@turf/turf';
import { Tb3DCubeSphere } from 'react-icons/tb';
import AlterStringMetricsInline from './alterStringMetricsInline.js';
import AlterNumericMetricsInline from './alterNumericMetricsInline.js';
import { BiSolidColor } from "react-icons/bi";
import { IoFilter } from "react-icons/io5";
import renderByDisplayHint from './renderByDisplayHint.js';

// Chart.register(zoomPlugin);

const ClickedInfoRealm = ({
    longstandingGeoJSONRef,
    globalState,
    globalRefs,
    isRealmLeftClickedInfoVisible,
    setIsRealmLeftClickedInfoVisible,
    polygonCustomLayerRef,
    featureList,
    setFeatureList,
    activeFeatureId,
    setActiveFeatureId,
    landKeySelectedKey,
    ResetMap
}) => {

    const { multuGroupSelectedArray, setMultuGroupSelectedArray, mapMetaData } = globalState;
    const originalGeoJSONforComparingRef = globalRefs.originalGeoJSONforComparingRef;
    const selectedMetric = globalState.selectedMetric;
    const devDeployment = globalState.devDeployment;
    const selectedYearEditing = globalState.selectedYearEditing;
    let mapRef = globalRefs.mapRef;
    let currentMapIdRef = globalRefs.currentMapIdRef;
    let workingLocally = globalState.workingLocally;
    let selectedRange = globalState.selectedRange;
    let setSelectedRange = globalState.setSelectedRange;
    let selectedAggregate = globalState.selectedAggregate;
    let setSelectedAggregate = globalState.setSelectedAggregate;
    let setSelectedMetric = globalState.setSelectedMetric;
    let setSelectedKey = globalState.setSelectedKey;
    let selectedKey = globalState.selectedKey;
    let setLandKeySelectedKey = globalState.setLandKeySelectedKey;
    let setSelectedYearEditing = globalState.setSelectedYearEditing;

    const [expandedChart, setExpandedChart] = useState(null);
    const [openMetrics, setOpenMetrics] = useState({});
    const [selectedTimestampToEditFromScatterGraph, setSelectedTimestampToEditFromScatterGraph] = useState('')
    const [selectedTimestampToEditFromLineGraph, setSelectedTimestampToEditFromLineGraph] = useState('');
    const [currentEditingStringValue, setCurrentEditingStringValue] = useState();
    const [openNumericMetric, setOpenNumericMetric] = useState(null);
    const [openCategoryMetric, setOpenCategoryMetric] = useState(null);
    const [availableNumericMetrics, setAvailableNumericMetrics] = useState([]);
    const [availableStringMetrics, setAvailableStringMetrics] = useState([]);
    const [metricChartData, setMetricChartData] = useState({});
    const [numericMetric, setNumericMetric] = useState(null);
    const [keyMetric, setKeyMetric] = useState(null);

    let showFilterFeatureDataSimpleTimeseriesModal = globalState.showFilterFeatureDataSimpleTimeseriesModal;
    let setShowFilterFeatureDataSimpleTimeseriesModal = globalState.setShowFilterFeatureDataSimpleTimeseriesModal;
    let setIsLoadingNewGeoJSONFromAnUpdate = globalState.setIsLoadingNewGeoJSONFromAnUpdate;
    let setAPIReportMessage = globalState.setAPIReportMessage;

    // Ref to track if initial metric selection has been set

    const hasInitRef = useRef(false);

    // INITIALIZE AVAILABLE METRICS

    useEffect(() => {
        if (!mapMetaData?.define_feature_data_simple_timeseries) return;

        const metaMetrics = mapMetaData.define_feature_data_simple_timeseries;
        const features = longstandingGeoJSONRef.current?.features || [];

        const hasHealthyProperty = (metric) => {
            return features.some(feature => {
                const value = feature?.feature_data_simple_timeseries?.[metric];

                return value !== undefined &&
                    value !== null &&
                    value !== '';
            });
        };

        const allMetrics = Object.keys(metaMetrics);
        const numeric = [];
        const string = [];

        allMetrics.forEach(metric => {
            // Don't add metrics that don't actually exist on the features
            if (!hasHealthyProperty(metric)) return;

            const meta = metaMetrics[metric];

            if (meta?.display_hint === "chartdata_line") {
                numeric.push(metric);
            } else {
                const isNumeric = meta?.type === "number";

                if (isNumeric) {
                    numeric.push(metric);
                } else {
                    string.push(metric);
                }
            }
        });

        setAvailableNumericMetrics(numeric);
        setAvailableStringMetrics(string);
    }, [mapMetaData, longstandingGeoJSONRef]);

    // 

    const getOrderedVisibleMetrics = (metrics) => {
        const metadata =
            mapMetaData?.define_feature_data_simple_timeseries || {};

        return [...metrics]
            .filter((metric) => {
                const meta = metadata[metric];

                return meta?.display_by_default === true;
            })
            .sort((a, b) => {
                const metaA = metadata[a] || {};
                const metaB = metadata[b] || {};

                const orderA =
                    typeof metaA.display_order === 'number'
                        ? metaA.display_order
                        : Number.MAX_SAFE_INTEGER;

                const orderB =
                    typeof metaB.display_order === 'number'
                        ? metaB.display_order
                        : Number.MAX_SAFE_INTEGER;

                if (orderA !== orderB) {
                    return orderA - orderB;
                }

                const nameA = metaA.name || a;
                const nameB = metaB.name || b;

                return nameA.localeCompare(nameB, undefined, {
                    sensitivity: 'base',
                    numeric: true
                });
            });
    };

    // Set initial open metric and selected metric/key on first load

    useEffect(() => {
        if (hasInitRef.current) return;

        const orderedNumericMetrics =
            getOrderedVisibleMetrics(availableNumericMetrics);

        const orderedStringMetrics =
            getOrderedVisibleMetrics(availableStringMetrics);

        if (orderedNumericMetrics.length) {
            setOpenNumericMetric(orderedNumericMetrics[0]);
            setNumericMetric(orderedNumericMetrics[0]);
            setSelectedMetric(orderedNumericMetrics[0]);
        }

        if (orderedStringMetrics.length) {
            setOpenCategoryMetric(orderedStringMetrics[0]);
            setKeyMetric(orderedStringMetrics[0]);
            setSelectedKey(orderedStringMetrics[0]);
            setLandKeySelectedKey(orderedStringMetrics[0]);
        }

        hasInitRef.current = true;

    }, [availableNumericMetrics, availableStringMetrics, mapMetaData]);

    // Handle feature selection and opacity adjustments when multuGroupSelectedArray changes

    useEffect(() => {
        if (!Array.isArray(multuGroupSelectedArray) || (!fmeshPoints && !fmesh)) return;
        const processMeshGroup = (meshGroup, checkCollisions = false) => {
            if (!meshGroup) return [];
            const newFeatureList = [];
            multuGroupSelectedArray.forEach(skylarkId => {
                const feature = longstandingGeoJSONRef?.current?.features?.find(
                    f => f.skylark_id === skylarkId
                );
                if (!feature) return;
                const clickedMesh = meshGroup.children.find(m => m.name === skylarkId);
                if (!clickedMesh) return;
                newFeatureList.push({ feature, mesh: clickedMesh });
                if (checkCollisions) {
                    const clickedBox = new THREE.Box3().setFromObject(clickedMesh);
                    const collidingMeshes = meshGroup.children.filter(otherMesh => {
                        if (otherMesh === clickedMesh) return false;
                        const otherBox = new THREE.Box3().setFromObject(otherMesh);
                        return clickedBox.intersectsBox(otherBox);
                    });
                    collidingMeshes.forEach(m => {
                        const collidedFeature = longstandingGeoJSONRef?.current?.features?.find(
                            f => f.skylark_id === m.name
                        );
                        if (collidedFeature) {
                            newFeatureList.push({ feature: collidedFeature, mesh: m });
                        }
                    });
                }
            });
            return Array.from(
                new Map(newFeatureList.map(f => [f.feature.skylark_id, f])).values()
            );
        };
        const uniqueListPoints = processMeshGroup(fmeshPoints, true);
        const uniqueListMeshes = processMeshGroup(fmesh, false);
        const combinedUniqueList = Array.from(
            new Map(
                [...uniqueListPoints, ...uniqueListMeshes].map(f => [f.feature.skylark_id, f])
            ).values()
        );
        setFeatureList(combinedUniqueList);
        if (combinedUniqueList.length === 0) {
            if (fmeshPoints) polygonCustomLayerRef.current.resetFeatureOpacitiesPointsOnly(fmeshPoints);
            if (fmesh) polygonCustomLayerRef.current.resetFeatureOpacitiesPointsOnly(fmesh);
        } else {
            if (fmeshPoints) polygonCustomLayerRef.current.adjustFeatureOpacitiesPoints(
                fmeshPoints, combinedUniqueList.map(f => f.feature.skylark_id)
            );
            if (fmesh) polygonCustomLayerRef.current.adjustFeatureOpacitiesPoints(
                fmesh, combinedUniqueList.map(f => f.feature.skylark_id)
            );
        }
        if (combinedUniqueList.length > 0) setActiveFeatureId(combinedUniqueList[0].feature.skylark_id);
    }, [multuGroupSelectedArray, longstandingGeoJSONRef, fmeshPoints, fmesh]);

    // Get active feature details

    const activeFeature = featureList.find(f => f.feature.skylark_id === activeFeatureId);

    // Utility to get latest timeseries entry for a metric

    const getLatestTimeseriesEntry = (timeMap = {}) => {
        const entries = Object.entries(timeMap);
        if (!entries.length) return { timestamp: null, value: null };
        const [timestamp, value] = entries[0];
        return { timestamp, value };
    };

    // Toggle function for opening/closing metric details

    const openMetricByKey = (metricKey) => {
        const isNumeric = availableNumericMetrics.includes(metricKey);
        if (isNumeric) {
            setOpenNumericMetric(metricKey);
            setSelectedMetric(metricKey);
        } else {
            setOpenCategoryMetric(metricKey);
            setSelectedKey(metricKey);
            setLandKeySelectedKey(metricKey);
        }
    };

    useEffect(() => {
        if (selectedMetric) {
            setOpenNumericMetric(selectedMetric);
        }
    }, [selectedMetric]);

    useEffect(() => {
        if (selectedKey) {
            setOpenCategoryMetric(selectedKey);
        }
    }, [selectedKey]);

    // Handle metric click to set selected metric or key

    const handleMetricClick = ({ metric, isNumeric }) => {
        if (isNumeric) {
            setSelectedMetric(metric);
        } else {
            setSelectedKey(metric);
            setLandKeySelectedKey(metric);
        }
    };

    // Effect to update metric chart data when the geoJSON or selected metric changes

    useEffect(() => {
        if (!longstandingGeoJSONRef.current) return;
        const dataById = {};
        longstandingGeoJSONRef.current.features.forEach(feature => {
            dataById[feature.skylark_id] =
                feature.feature_data_simple_timeseries;
        });
        setMetricChartData(prev => {
            const updated = { ...prev };
            Object.entries(dataById).forEach(([id, timeseries]) => {
                updated[id] = {
                    ...(updated[id] || {}),
                    ...timeseries,   // store full timeseries object
                };
            });
            return updated;
        });
    }, [longstandingGeoJSONRef.current, selectedMetric]);

    // Function to render metric item with appropriate display based on hints and type

    const renderMetricItem = (metricKey) => {
        const timeMap = {
            ...(metricChartData[activeFeature.feature.skylark_id]?.[metricKey] ||
                activeFeature.feature.feature_data_simple_timeseries?.[metricKey] || {})
        };
        const latestEntry = getLatestTimeseriesEntry(timeMap);
        let meta = mapMetaData?.define_feature_data_simple_timeseries?.[metricKey] || {};
        meta.display_hint = meta.display_hint ?? (
            typeof latestEntry.value === 'number' ? 'chartdata_line' : 'default'
        );
        const displayHints = meta.display_hint
            .split(',')
            .map(h => h.trim())
            .filter(Boolean);
        const lowerThreshold = activeFeature.feature.feature_data_simple?._rlm_csg_lower_th?.[metricKey];
        const upperThreshold = activeFeature.feature.feature_data_simple?._rlm_csg_upper_th?.[metricKey];
        const isNumeric = availableNumericMetrics.includes(metricKey);

        const isOpen = isNumeric
            ? openNumericMetric === metricKey
            : openCategoryMetric === metricKey;

        const hint = displayHints?.[0];

        const shouldRenderLineChart = hint === "chartdata_line" || hint === "quantifiable" || (typeof latestEntry.value === "number");

        const shouldRenderScatter = typeof latestEntry.value === "string" && !displayHints.includes("string");

        const shouldRenderDefault = hint === "default";

        let orangeColor = '#c97b06';

        const borderColor = !isNumeric ? orangeColor : orangeColor;
        const isScenarioMetric = ["BD_Parcel", "ParcelCarbon", "HabitatType"].includes(metricKey);
        const scenarioModelingIsActive = Boolean(globalState.scenarioModelingModeActive);

        const selectedYearValue =
            selectedYearEditing && timeMap?.[selectedYearEditing] !== undefined
                ? timeMap[selectedYearEditing]
                : null;

        setIsLoadingNewGeoJSONFromAnUpdate(false)

        // CHECK IF metricMissingAtSelectedTimestamp

        const metricMissingAtSelectedTimestamp = (() => {
            if (!selectedYearEditing || !timeMap) {
                return false;
            }

            const targetTime = new Date(selectedYearEditing).getTime();

            return !Object.entries(timeMap).some(([ts, val]) =>
                new Date(ts).getTime() === targetTime &&
                val !== undefined &&
                val !== null &&
                val !== ""
            );
        })();

        return (
            <div key={metricKey} style={{
                marginBottom: '5px',
                borderRadius: '3px',
                borderTop: `1px solid ${borderColor}`,
                borderRight: `1px solid ${borderColor}`,
                borderBottom: `1px solid ${borderColor}`,
                borderLeft: isScenarioMetric && scenarioModelingIsActive
                    ? '4px solid #D63384'
                    : `1px solid ${borderColor}`,
                // padding: '5px'
                paddingLeft: '0px',
            }}>
                <p
                    onClick={() => {
                        openMetricByKey(metricKey);
                    }}
                    style={{
                        margin: '0 0 0 0',
                        fontSize: '10px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    {/* LEFT SIDE */}
                    {/* LEFT SIDE */}
                    <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <span>
                            {/* {isOpen ? <IoIosArrowDown /> : <IoIosArrowForward />} */}
                        </span>

                        <span>{meta.name}: </span>

                        {selectedYearValue !== null && (
                            <span style={{
                                fontSize: '9px',
                                fontWeight: 'bold',
                                opacity: 0.7,
                                marginLeft: '4px'
                            }}>
                                {selectedYearValue}
                                {meta?.unit ? ` ${meta.unit}` : ''}
                            </span>
                        )}
                    </span>

                    {/* RIGHT SIDE ICON */}
                    <span
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            color: "#fff",
                            fontSize: "14px",
                            opacity: isNumeric
                                ? metricKey === selectedMetric ? 1 : 0.3
                                : metricKey === landKeySelectedKey ? 1 : 0.3,
                            backgroundColor: isNumeric
                                ? metricKey === selectedMetric ? orangeColor : orangeColor
                                : metricKey === landKeySelectedKey ? orangeColor : orangeColor,
                            padding: '6px 8px',
                            textAlign: 'center',
                            lineHeight: '20px',
                        }}
                    >
                        {isNumeric ? <Tb3DCubeSphere /> : <BiSolidColor />}
                    </span>
                </p>
                {isOpen && (
                    <div style={{
                        marginTop: '10px',
                        marginLeft: '0px'
                    }}>

                        {shouldRenderScatter && (
                            <div style={{
                                position: 'relative', padding: "5px"
                            }}>
                                {!metricMissingAtSelectedTimestamp && (
                                    <AlterStringMetricsInline
                                        globalState={globalState}
                                        globalRefs={globalRefs}
                                        catgeoryPropertyName={meta.name}
                                        selectedTimestampToEditFromScatterGraph={selectedTimestampToEditFromScatterGraph}
                                        setSelectedTimestampToEditFromScatterGraph={setSelectedTimestampToEditFromScatterGraph}
                                    />
                                )}
                                <DynamicScatterChart
                                    value={timeMap || {}}
                                    catgeoryPropertyName={meta.name}
                                    metricKey={metricKey}
                                    activeFeatureId={activeFeature.feature.skylark_id}
                                    height={160}
                                    globalState={globalState}
                                    globalRefs={globalRefs}
                                    selectedTimestampToEditFromScatterGraph={selectedTimestampToEditFromScatterGraph}
                                    setSelectedTimestampToEditFromScatterGraph={setSelectedTimestampToEditFromScatterGraph}
                                    setSelectedYearEditing={setSelectedYearEditing}
                                />
                            </div>
                        )}

                        {shouldRenderLineChart && (
                            <div style={{
                                position: 'relative', padding: "5px"
                            }}>
                                {!metricMissingAtSelectedTimestamp && (
                                    <AlterNumericMetricsInline
                                        globalState={globalState}
                                        globalRefs={globalRefs}
                                        valuePropertyName={meta.name}
                                        selectedTimestampToEditFromLineGraph={selectedTimestampToEditFromLineGraph}
                                        setSelectedTimestampToEditFromLineGraph={setSelectedTimestampToEditFromLineGraph}
                                    />
                                )}

                                <DynamicLineChart
                                    value={timeMap || {}}
                                    valuePropertyName={meta.name}
                                    comparisonValue={
                                        metricChartData[activeFeature.feature.skylark_id]?.[metricKey] ||
                                        originalGeoJSONforComparingRef?.current?.features?.find(
                                            f => f.skylark_id === activeFeature.feature.skylark_id
                                        )?.feature_data_simple_timeseries?.[metricKey]
                                    }
                                    unit={meta?.unit || ''}
                                    lowerThreshold={lowerThreshold}
                                    upperThreshold={upperThreshold}
                                    height={160}
                                    isEnlarged={false}
                                    selectedYearEditing={selectedYearEditing}
                                    selectedAggregate={selectedAggregate}
                                    selectedRange={selectedRange}
                                    selectedTimestampToEditFromLineGraph={selectedTimestampToEditFromLineGraph}
                                    setSelectedTimestampToEditFromLineGraph={setSelectedTimestampToEditFromLineGraph}
                                    multuGroupSelectedArray={multuGroupSelectedArray}
                                    setSelectedYearEditing={setSelectedYearEditing}
                                />
                            </div>
                        )}

                    </div>
                )}
            </div>
        );
    };

    useEffect(() => {
        if (!featureList.length) return;
        const firstId = featureList[0].feature.skylark_id;
        const initialState = {};
        featureList.forEach(({ feature }) => {
            initialState[feature.skylark_id] = feature.skylark_id === firstId;
        });
        setOpenMetrics(initialState);
        setActiveFeatureId(firstId);
    }, [featureList]);

    // Function to render values based on display hints

    return (
        <>
            {(
                <div className="select-container">
                    <div style={{ marginTop: '0px', width: '355px', marginLeft: '0px' }}>
                        <div
                            style={{
                                height: '90%',
                                overflowY: 'auto',
                                // marginBottom: '10px',
                                marginTop: '10px'
                            }}
                        >
                            {/* <b>Metrics for {featureList.length} selected feature: </b><br /><br /> */}
                            {featureList.map(({ feature }, index) => {
                                let displayName = feature.feature_data_simple.shortname;
                                const isOpen = openMetrics[feature.skylark_id] || false;
                                return (
                                    <div key={feature.skylark_id} style={{}}>

                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <b>Inspecting Metrics for {displayName}</b>

                                            <button
                                                style={{
                                                    backgroundColor: '#fff',
                                                    border: '1px solid #29645D',
                                                    color: '#29645D',
                                                    paddingTop: '5px',
                                                    paddingBottom: '5px',
                                                    width: '55px',
                                                    borderRadius: '3px',
                                                    fontSize: '10px'
                                                }}
                                                onClick={() => setShowFilterFeatureDataSimpleTimeseriesModal(true)}
                                            >
                                                <IoFilter />
                                            </button>
                                        </div>

                                        <br />
                                        {/* <div
                                            style={{
                                                padding: '6px',
                                                cursor: 'pointer',
                                                width: '95%',
                                                borderRadius: '3px',
                                                border: isOpen ? "1px solid #29645D" : "1px solid #29645D",
                                                fontSize: '12px',
                                                display: 'inline-block',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                backgroundColor: isOpen ? '#ecf0ef' : 'transparent',
                                                color: isOpen ? '#29645D' : '#29645D',
                                            }}
                                            onClick={() => {
                                                const clickedId = feature.skylark_id;
                                                setActiveFeatureId(clickedId);
                                                setOpenMetrics(prev => {
                                                    const newState = {};
                                                    Object.keys(prev).forEach(id => {
                                                        newState[id] = id === clickedId;
                                                    });
                                                    return newState;
                                                });
                                            }} 
                                        >

                                            <div style={{ display: 'inline-block' }}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <span
                                                        style={{
                                                            maxWidth: '150px',
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            fontSize: '10px',
                                                            textOverflow: 'ellipsis',
                                                            display: 'inline-block',
                                                        }}
                                                    >
                                                        {displayName}
                                                    </span>
                                                </div>
                                            </div>
                                        </div> */}

                                        {activeFeature && feature.skylark_id === activeFeatureId && (
                                            <div
                                                style={{
                                                    marginLeft: '0px',
                                                    marginTop: '0px',
                                                }}
                                            >

                                                {availableNumericMetrics.length > 0 && (
                                                    <div style={{ marginBottom: '10px' }}>
                                                        <p style={{
                                                            fontSize: '9px',
                                                            fontWeight: 'bold',
                                                            color: '#29645D',
                                                            margin: '5px 0'
                                                        }}>
                                                            Values
                                                        </p>
                                                        {getOrderedVisibleMetrics(availableNumericMetrics)
                                                            .map((metricKey) => {
                                                                const isOpen = openNumericMetric === metricKey;

                                                                return renderMetricItem(
                                                                    metricKey,
                                                                    true,
                                                                    isOpen
                                                                );
                                                            })}
                                                    </div>
                                                )}

                                                {availableStringMetrics.length > 0 && (
                                                    <div style={{ marginBottom: '10px' }}>
                                                        <p style={{
                                                            fontSize: '9px',
                                                            fontWeight: 'bold',
                                                            color: '#29645D',
                                                            margin: '5px 0'
                                                        }}>
                                                            Categories
                                                        </p>
                                                        {getOrderedVisibleMetrics(availableStringMetrics)
                                                            .map((metricKey) => {
                                                                const isOpen = openCategoryMetric === metricKey;

                                                                return renderMetricItem(
                                                                    metricKey,
                                                                    false,
                                                                    isOpen
                                                                );
                                                            })}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ClickedInfoRealm;
